var _g;

var _excluded = ["title", "titleId"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) { o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } } return t; }

import * as React from "react";

function SvgGenericCompanyLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "49.422mm",
    height: "49.37mm",
    viewBox: "0 0 49.422 49.37",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-29.286 -14.04)",
    strokeWidth: 0.26458
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#005b70",
    d: "m54.366 63.245c0-0.38489 8.8728-8.8757 10.438-9.9882 2.7416-1.9492 6.3463-2.4077 9.489-1.2071l0.74421 0.28432-0.8765 1.2209c-2.9782 4.1485-8.6386 7.8372-14.15 9.2208-2.1877 0.54927-5.6446 0.83662-5.6446 0.4692z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f66633",
    d: "m51.721 36.872c-4.4863-1.2602-7.7016-4.7708-8.4839-9.2632-1.129-6.4833 3.1287-12.407 9.646-13.42 5.9119-0.9191 11.329 2.5228 12.902 8.1985 0.86121 3.1058 0.54256 5.8282-1.0373 8.8625-2.3529 4.5189-8.11 7.0036-13.027 5.6224z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#009dc1",
    d: "m37.453 56.929c-6.7569-6.2559-9.5094-14.878-7.5491-23.648 0.77773-3.4792 2.5023-7.0061 2.5023-5.1175 0 0.22183 0.3571 1.2952 0.79357 2.3852 2.0414 5.0981 6.7267 10.195 11.642 12.665 1.9319 0.97074 4.7869 1.9278 6.382 2.1394 0.70998 0.09418 1.2909 0.24611 1.2909 0.33761 0 0.21603-12.784 12.995-13.001 12.995-0.09033 0-1.0178-0.79027-2.0611-1.7562z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#005b70",
    d: "m46.184 62.117c-1.226-0.42486-2.3537-0.8972-2.5062-1.0496-0.19316-0.19316 2.3268-2.8857 8.3144-8.8841 4.7254-4.7338 9.3655-9.2411 10.311-10.016 3.8774-3.1775 7.7922-4.2091 12.11-3.1912 2.5073 0.59116 4.2944 1.5777 4.2944 2.3707 0 1.4101-1.4362 7.0202-1.7971 7.0199-0.10298-7.4e-5 -0.84208-0.26367-1.6424-0.58577-1.2213-0.49149-1.9656-0.5854-4.6302-0.58416-5.5227 0.0026-7.0859 0.94838-15.768 9.54-3.4358 3.4002-6.2942 6.1756-6.3521 6.1676-0.05789-8e-3 -1.1083-0.36216-2.3343-0.78702z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGenericCompanyLogo);
export default __webpack_public_path__ + "static/media/generic-company-logo.1bf490da4552cece56915ce338a6ed67.svg";
export { ForwardRef as ReactComponent };